import { Component, OnInit } from '@angular/core';

declare interface RouteInfo {
    path: string;
    title: string;
    icon: string;
    class: string;
    isActive:number;
}
export const ROUTES: RouteInfo[] = [
    { path: '/dashboard', title: 'Dashboard',  icon: 'design_app', class: '',isActive:1},
    { path: '/users', title: 'Users',  icon:'education_atom', class: '',isActive:2 },
    { path: '/student', title: 'Student',  icon:'location_map-big', class: '' ,isActive:3},
    { path: '/university', title: 'University',  icon:'ui-1_bell-53', class: '' ,isActive:4},
    { path: '/subject', title: 'Subject',  icon:'users_single-02', class: '' ,isActive:5},
    { path: '/semester', title: 'Semester',  icon:'design_bullet-list-67', class: '' ,isActive:6},
    { path: '/finance', title: 'Finance',  icon:'objects_diamond', class: '' ,isActive:7},
    { path: '/product', title: 'Product',  icon:'shopping_cart-simple', class: '' ,isActive:8},
    { path: '/question', title: 'Question',  icon:'education_paper', class: '' ,isActive:9},
    { path: '/chapter', title: 'Chapter',  icon:'education_hat', class: '' ,isActive:10},
    { path: '/message', title: 'Message',  icon:'education_hat', class: 'nonDisplay' ,isActive:11},
    { path: '/myAccount', title: 'My Account',  icon:'education_hat', class: 'nonDisplay' ,isActive:12},
    { path: '/chart', title: 'Student Chart',  icon:'education_hat', class: 'nonDisplay' ,isActive:13}
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  menuItems: any[];
  currentUser:any;
  constructor() { 
   
  }
  getisActive(ItemInx){
    this.currentUser = JSON.parse(localStorage.getItem('UserInfo'));
 
    if(this.currentUser.userTypeId=="2"){
      return  true ;
    }else{
        var index = [2,3,4,5,6];
        console.log(index.indexOf(ItemInx.isActive)>=0);
        if(index.indexOf(ItemInx.isActive)>=0){
            return false;
        }else{
            return true;
        }
    }
  }
  ngOnInit() {
    this.menuItems = ROUTES.filter(menuItem => menuItem);
  }
  isMobileMenu() {
      if ( window.innerWidth > 991) {
          return false;
      }
      return true;
  };
}



// WEBPACK FOOTER //
// ./src/app/components/sidebar/sidebar.component.ts